import { derived, type Readable } from 'svelte/store';
import { user } from './stores/auth';

/**
 * Bridge between the user's persisted `sound_enabled` setting and the
 * @atlasguess/audio player. Modes mount an AudioPlayer at the start of
 * a round and need two things: an initial enabled state at construction
 * time (so a muted user never opens an AudioContext on the first click)
 * and a reactive subscription so flipping the setting in /account silences
 * any in-flight sequence immediately.
 *
 * Defaults to `true` when no user is signed in or no preference is set,
 * matching the historical default before this store existed (the audio
 * package itself defaults `enabled` to true too — the redundancy here
 * keeps the rule local).
 *
 * Usage in a mode:
 *   audio = createAudio({ enabled: $soundEnabled });
 *   $effect(() => { audio?.setEnabled($soundEnabled); });
 */
export const soundEnabled: Readable<boolean> = derived(user, ($user) => {
  return $user?.settings?.sound_enabled !== false;
});
